import { LocationCompany } from '../../components/location-company/LocationCompany';

export function PlacePage() {
  return <LocationCompany></LocationCompany>;
}
